enum QBDVersionEnum {
    PRO = "pro",
    PREMIERE = "premiere",
    ENTERPRISE = "enterprise",
}

export default QBDVersionEnum;
